import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from "@/components/layout/Layout";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/hooks/useAuth";
import { formatInTimeZone } from 'date-fns-tz';

const WebhookPage = () => {
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  if (!user || user.email !== 'ilwoonge@gmail.com') {
    navigate('/');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!input.trim()) {
      toast({
        variant: "destructive",
        title: "입력값이 필요합니다",
        description: "내용을 입력해주세요",
      });
      return;
    }
    
    setIsLoading(true);
    
    try {
      const currentTime = formatInTimeZone(new Date(), 'America/Los_Angeles', "yyyy-MM-dd'T'HH:mm:ssXXX");
      const payload = {
        data: input,
        timestamp: currentTime
      };
      
      console.log("Sending webhook data:", payload);
      
      const response = await fetch('https://ilwoonge.app.n8n.cloud/webhook/8c4164d8-cbc1-44d8-af42-a7bc7ef9e621', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      
      console.log("Webhook response status:", response.status);
      
      if (!response.ok) {
        const errorText = await response.text().catch(() => 'No error details available');
        console.error("Webhook error response:", errorText);
        throw new Error('웹훅 전송에 실패했습니다');
      }
      
      const responseData = await response.json().catch(() => null);
      console.log("Webhook response data:", responseData);
      
      toast({
        title: "전송 성공",
        description: "웹훅이 성공적으로 전송되었습니다",
      });
      
      setInput('');
    } catch (error) {
      console.error("Webhook error details:", error);
      toast({
        variant: "destructive",
        title: "전송 실패",
        description: "웹훅 전송 중 오류가 발생했습니다",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container mx-auto py-10">
        <Card className="max-w-lg mx-auto">
          <CardHeader>
            <CardTitle>웹훅 전송</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="전송할 내용을 입력하세요"
                disabled={isLoading}
              />
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? '전송 중...' : '전송하기'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default WebhookPage;
